enum TaxiCargoContractListingFilterType {
  BILLING_MODEL = "BILLING_MODEL",
  CARGO_COMPANY = "CARGO_COMPANY",
}

export default TaxiCargoContractListingFilterType;
